import styled from '@emotion/styled';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import { SubSectionDialogContent } from '@shared/components/core/layouts/CommonLayoutStyles';
import { BodyMedium } from '@shared/components/core/text/Typography';
import LicenseTypeLogo from '@shared/components/license/LicenseTypeLogo';
import { getLicenseType } from '@shared/constants/organization/LicenseUtils';
import LicenseKeyModel from '@shared/models/organizations/LicenseKeyModel';
import { useTranslation } from 'react-i18next';

export interface ILicenseKeyDetailsProps {
    licenseKey: LicenseKeyModel;
}

export default function LicenseKeyDetails({ licenseKey }: ILicenseKeyDetailsProps) {
    const { t, i18n } = useTranslation();
    return (
        <>
            <SubSectionRow title={licenseKey.name} variant="small" />
            <StyledLicenseTypeLogo licenseType={getLicenseType(licenseKey)} />
            <SubSectionDialogContent>
                <BodyMedium>{licenseKey.accessCode}</BodyMedium>
                <BodyMedium>{t('common:created', 'Created', { value: licenseKey.createdDate })}</BodyMedium>
                {licenseKey.modifiedDate !== licenseKey.createdDate && (
                    <BodyMedium>{t('common:updated', 'Updated', { value: licenseKey.modifiedDate })}</BodyMedium>
                )}
                <BodyMedium>{t('common:expires', 'Expires', { value: licenseKey.expirationDate })}</BodyMedium>
                <BodyMedium>
                    {t('common:organization.member.seats.maxSeatValue', 'Max', { value: licenseKey.maxMembers })}
                </BodyMedium>
            </SubSectionDialogContent>
        </>
    );
}

// TODO - this is a hack to get the icons to work correctly I have put in a ticket with the team to get better license logos
const StyledLicenseTypeLogo = styled(LicenseTypeLogo)`
    position: relative;
    margin-top: -80px;
    overflow: hidden;
    bottom: -50px;
`;
